import { nextTick, onMounted, ref, watch } from 'vue';

export interface Props {
  fieldName: string;
  row: any;
  cells: string[];
}

export interface Emit {
  (e: 'click-cell', value: { field: string; value: string[]; row: any }, event: MouseEvent): void;
}

const CSS_ELE = {
  cntMarkWidth: 32,
  ballWidth: 12,
  gap: 5,
};

const setup = (props: Props, emit: Emit) => {
  const baseGridBallsEle = ref();
  const filteredCells = ref<string[]>([]);
  const moreCnt = ref<number>(0);

  const setFilteredChips = async () => {
    await nextTick();

    const targetCellWidth = baseGridBallsEle.value?.getBoundingClientRect().width;
    const cellsCnt = props.cells?.length;

    if (baseGridBallsEle.value && cellsCnt > 1) {
      const childTotalWidth = CSS_ELE.ballWidth * cellsCnt + CSS_ELE.gap * (cellsCnt - 1);

      if (childTotalWidth >= targetCellWidth) {
        const showingEleCnt = Math.floor(
          (targetCellWidth - CSS_ELE.cntMarkWidth) / (CSS_ELE.ballWidth + CSS_ELE.gap),
        );

        if (showingEleCnt < 0) {
          filteredCells.value = [];
          moreCnt.value = cellsCnt;
          return;
        }

        filteredCells.value = props.cells.slice(0, showingEleCnt);
        moreCnt.value = cellsCnt - showingEleCnt;
        return;
      }
    }

    filteredCells.value = props.cells;
    moreCnt.value = 0;
  };

  const clickCell = (field, value, row, event) => {
    emit(
      'click-cell',
      {
        field,
        value,
        row,
      },
      event,
    );
  };

  const getContainersColorBall = (status: string) => {
    switch (status.toLocaleLowerCase()) {
      case 'running':
        return 'running';
      case 'pending':
      case 'stop':
      case 'waiting':
        return 'pending';
      case 'failed':
        // case 'terminated':
        return 'failed';
      case 'terminated':
      case 'unknown':
        return 'unknown';
      default:
        return '';
    }
  };

  const ro = new ResizeObserver(async () => {
    await setFilteredChips();
  });

  watch(
    () => props.cells,
    async () => {
      await setFilteredChips();
    },
    { immediate: true },
  );

  onMounted(() => {
    ro.observe(baseGridBallsEle.value!);
  });

  return { filteredCells, baseGridBallsEle, moreCnt, clickCell, getContainersColorBall };
};

export { setup };
